import { EventStatistic } from '@entities/event';

export const STATISTIC_TYPE = {
  GENERAL: 0,
  LEAD_COLLECTOR: 1,
  INVITATIONS: 2,
  TICKETS: 3,
};

export const DEFAULT_TYPE_STATISTIC = STATISTIC_TYPE.GENERAL;

export const EVENT_STATISTICS: EventStatistic[] = [
  {
    id: STATISTIC_TYPE.GENERAL,
    name: 'Общая',
    description: 'Общая статистика мероприятия',
    labels: ['Приглашений', 'Принято', 'Присутствовал', 'Не присутствовал'],
    values: ['total', 'countAcceptedInvites', 'checkedCount', 'falsedCount'],
  },
  {
    id: STATISTIC_TYPE.LEAD_COLLECTOR,
    name: 'Лидосборщик',
    description: 'Количество успешных регистраций',
    labels: ['Всего гостей', 'Взрослые', 'Гости с детьми', 'Дети'],
    values: ['total', 'countAdultGuests', 'countAdultWithChildGuests', 'countChildGuests'],
  },
  {
    id: STATISTIC_TYPE.INVITATIONS,
    name: 'Приглашения',
    description: 'Сводные данные по приглашениям',
    labels: ['Всего отправлено', 'Принято', 'Отклонено'],
    values: ['totalInvites', 'countAcceptedInvites', 'countDeclinedInvites'],
  },
  {
    id: STATISTIC_TYPE.TICKETS,
    name: 'Билеты',
    description: 'Статистика посещения мероприятия',
    labels: ['Всего отправлено', 'Присутствовал', 'Не присутствовал'],
    values: ['ticketsSent', 'checkedCount', 'falsedCount'],
  },
];

export enum EVENT_PAGE_TABS {
  events = 'events',
  clients = 'clients',
}
